import React from 'react';
import story from "../../assets/global.PNG";
import transport from "../../assets/logo/transport.jpg";
import AboutBanner from '../AboutUs/AboutBanner';
import SisterConcerms from '../AboutUs/SisterConcerms';
import Achievements from '../AboutUs/Achievements';

const OurStory = () => {

  const isMobile = window.innerWidth <= 768;
  return (
    <div style={{ background: "#fff", paddingBottom: "15px" }}>
      {/* Banner */}

      <AboutBanner text={"Our Story"} des={"From a Shared Dream to a Diversified Business Group"}></AboutBanner>
      {/* Story Section - Added id="our-story" */}
      <section className="about-story mobile-responsive about-us-section">
        <div className="story-image">
          <img src={story} alt="Iconic Unity Group" />
        </div>


        {/* <div style={{ flex: "1", minWidth: "300px" }}>
          <h2 style={{ color: "#333", fontSize: "2rem", marginBottom: "20px" }}>Five Friends, One Vision</h2>
          <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "15px" }}>
            On <strong>03 April 2024</strong>, five visionary entrepreneurs came together with a shared belief that success is built through unity, trust, and collaboration. Rather than pursuing individual ventures, they chose to combine their knowledge, experience, and resources to build something greater.
          </p>
          <p style={{ color: "#555", lineHeight: "1.8" }}>
            This collective vision led to the establishment of <strong>Iconic Unity Group (IUG)</strong> a platform where businesses could grow together under one shared mission.
          </p>
        </div> */}
        <div
          style={{
            flex: "1",
            minWidth: "280px",
            width: "100%",
          }}
        >
          <h2
            style={{
              color: "#333",
              fontSize: "clamp(1.6rem, 4vw, 2rem)",
              marginBottom: "20px",
              lineHeight: "1.3",
            }}
          >
            Five Friends, One Vision
          </h2>

          <p
            style={{
              color: "#555",
              lineHeight: "1.8",
              marginBottom: "15px",
              fontSize: "clamp(0.95rem, 2vw, 1rem)",
            }}
          >
            On <strong>03 April 2024</strong>, five visionary entrepreneurs came
            together with a shared belief that success is built through unity,
            trust, and collaboration. Rather than pursuing individual ventures,
            they chose to combine their knowledge, experience, and resources to
            build something greater.
          </p>

          <p
            style={{
              color: "#555",
              lineHeight: "1.8",
              fontSize: "clamp(0.95rem, 2vw, 1rem)",
            }}
          >
            This collective vision led to the establishment of{" "}
            <strong>Iconic Unity Group (IUG)</strong>, a platform where businesses
            could grow together under one shared mission.
          </p>
        </div>
      </section>

      <section style={{ padding: isMobile ? "0px 20px" : "20px 10%", marginTop: isMobile ? "-40px" : "0px" }}>
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "50px",
          maxWidth: "1440px",
          margin: "0 auto"
        }}>

          {/* Left Side: Content */}
          <div style={{ flex: "1.2", minWidth: "300px", textAlign: "left" }}>
            <h2 style={{ color: "#4A00E0", fontSize: "2.2rem", marginBottom: "15px", fontWeight: "bold" }}>
              The Business of Bus
            </h2>
            <div style={{ width: "70px", height: "4px", background: "#7B1FA2", marginBottom: "25px" }}></div>
            <p style={{ fontSize: "1.15rem", color: "#444", lineHeight: "1.8" }}>
              Their entrepreneurial journey began with an investment in the transportation sector.
              Recognizing the growing demand for safe, comfortable, and reliable intercity travel,
              they entered the bus transportation industry as their first business venture.
              This decision laid the foundation for what would become a much larger business ecosystem.
            </p>
          </div>

          {/* Right Side: Image */}
          <div style={{ flex: "1", minWidth: "300px" }}>
            <img
              src={transport}
              alt="Transportation Business"
              style={{
                width: "100%",
                borderRadius: "20px",
                objectFit: "cover",
                display: "block"
              }}
            />
          </div>

        </div>
      </section>

      {/* 4. Iconic Express & IUG Formation (The Core Growth) */}
      <section style={{ padding: "40px 10%", }}>
        <div style={{ maxWidth: "1440px", margin: "0 auto 20px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "40px" }}>

          {/* The Birth of Iconic Express */}
          <div style={{ padding: "30px", borderLeft: "5px solid #4A00E0", background: "#fbfaff" }}>
            <h3 style={{ color: "#4A00E0" }}>The Birth of Iconic Express</h3>
            <p style={{ lineHeight: "1.7", color: "#555", marginTop: "15px" }}>
              The first company established was <strong>Iconic Express Ltd.</strong>, a premium intercity bus transportation company. With a strong focus on service quality and passenger comfort, it quickly became the cornerstone of their journey, proving that their collaborative approach could achieve meaningful success.
            </p>
          </div>

          {/* The Formation of Iconic Unity Group */}
          <div style={{ padding: "30px", borderLeft: "5px solid #1976D2", background: "#f5f9ff" }}>
            <h3 style={{ color: "#1976D2" }}>The Formation of Iconic Unity Group</h3>
            <p style={{ lineHeight: "1.7", color: "#555", marginTop: "15px" }}>
              As the founders shared their vision, the response was overwhelmingly positive. More people expressed interest in becoming part of a larger business platform. This led to the establishment of <strong>Iconic Unity Group (IUG)</strong> a diversified platform designed to support innovative ventures and create long-term value through strategic partnerships.
            </p>
          </div>

        </div>
      </section>

      <div className="about-us-section">

        {/* Achievements */}
        <Achievements></Achievements>
        {/* Sister Concern */}
        <SisterConcerms></SisterConcerms>
      </div>
    </div>
  );
};

export default OurStory;

